<template>
  <v-dialog max-width="500px" v-model="dialog" scrollable>
    <v-card>
      <v-toolbar dark>
        <v-toolbar-title class="headline">{{ formTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-icon>close</v-icon>
      </v-toolbar>
      <v-card-text style="height: auto"> ddd </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" flat>Cancel</v-btn>
        <v-btn color="green" flat>Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["dialog", "editedIndex", "selectedItem"],
  data() {
    return {
      updating_data: false,
      logoSrc: null,
      valid: true,
      change_logo: 0,
      validation: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  computed: {
    ...mapState({
      services: (state) => state.fetchStoreBack.store_type.store_services,
    }),
    formTitle() {
      return this.editedIndex === -1 ? "New user" : "Edit user";
    },
  },
};
</script>




